import Vue from 'vue'
import { decode } from 'utils/general'
import { mapState, mapActions } from 'vuex'
import select from 'dom-select'
import { i18n } from 'lib/i18n.js'
import brandTagDisplay from 'mixins/brand-tag'

Vue.component('product-hero', resolve => {
  Promise.all([
    enqueueModule('product-form.vue'),
    enqueueModule('product-gallery.vue'),
    enqueueModule('zoom-gallery.vue')
  ]).then(() => resolve({
    mixins: [brandTagDisplay],
    props: ['productJson', 'variants', 'parse'],
    computed: {
      ...mapState('product', [
        'product'
      ]),
      ...mapState('product', [
        'activeVariant'
      ]),
      productObject () {
        return this.parse ? JSON.parse(decode(this.productJson)) : this.productJson
      }
    },
    data () {
      return {
        descriptionExpanded: false
      }
    },
    mounted () {
      if (this.productObject) {
        const variants = this.productObject.variants
        const initialVariantId = String(this.productObject.id)
        const selectedVariant = variants.find(v => String(v.id) === initialVariantId) || variants[0]
        this.updateProduct(this.productObject)
        this.setActiveVariant(selectedVariant)
      }
    },
    methods: {
      ...mapActions('product', [
        'updateProduct',
        'setActiveVariant'
      ]),
      toggleDescription () {
        this.descriptionExpanded = !this.descriptionExpanded
        const wysiwyg = select('.product-description .wysiwyg')

        if (this.descriptionExpanded) {
          this.$refs.descriptionContainer.style.maxHeight = `${wysiwyg.clientHeight}px`
        } else {
          this.$refs.descriptionContainer.style.maxHeight = 0
        }
      },
    },
    i18n
  }))
})
